import React from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import InputMask from 'react-input-mask';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: 2,
        borderRadius: '50%', // Isso tornará o botão circular
        minWidth: '30px', // Largura mínima do botão
        height: '30px', // Altura do botão para torná-lo um círculo
        color: theme.palette.getContrastText('#4851de'), // Cor do texto
        backgroundColor: '#4851de', // Cor de fundo para botões ativos
        '&:disabled': {
            backgroundColor: theme.palette.action.disabledBackground, // Cor de fundo para botões inativos
        },
        fontFamily: 'montserrat',
        fontWeight: 'bold',
        // marginLeft: -20,
        marginTop: 5
    }
}));

const theme = createMuiTheme({
    overrides: {
        MuiInputBase: {
            input: {
                fontSize: 12,
            },
        },
    },
});

const ConfigDays = ({ viewEmployeeRegistration ,isModal}) => {
    const classes = useStyles();

    return (
        <div style={{ marginLeft: isModal? -26: -26, marginTop: 20, position: 'relative', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            {viewEmployeeRegistration.days.map((day) => (
                <Grid container style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', maxWidth: '100%' }}>
                    <Button
                        key={day.day}
                        className={classes.button}
                        style={{ backgroundColor: day.isWorking ? 'blue' : 'gray' }}
                        onClick={() => {
                            if (viewEmployeeRegistration.updatedHoursSchedule) {
                                viewEmployeeRegistration.getDays(true, day.day, viewEmployeeRegistration.selectedSchedule);
                            }
                        }}
                    >
                        {day.value}
                    </Button>
                    {day.isWorking ?
                        <ThemeProvider theme={theme}>
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10, flexWrap: 'wrap', maxWidth: '100%' }}>
                                <TextField
                                    key={day.day}
                                    id="outlined-basic"
                                    variant="outlined"
                                    size="small"
                                    value={day?.firstShiftIni}
                                    onChange={event => viewEmployeeRegistration.handleChangeHorary(event, 'firstShiftIni', null, day)}
                                    style={styles.tyleInput}
                                    InputProps={{
                                        style: styles.inputStyles,
                                        inputComponent: InputMask,
                                        inputProps: {
                                            mask: '99:99',
                                            alwaysShowMask: false,
                                        },
                                    }}
                                />
                                <span style={{ margin: '0 7px' }}> - </span>
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    size="small"
                                    value={day?.firstShiftEnd}
                                    onChange={event => viewEmployeeRegistration.handleChangeHorary(event, 'firstShiftEnd', null, day)}
                                    style={styles.tyleInput}
                                    InputProps={{
                                        style: styles.inputStyles,
                                        inputComponent: InputMask,
                                        inputProps: {
                                            mask: '99:99',
                                            alwaysShowMask: false,
                                        },
                                    }}
                                />
                                <span style={{ margin: '0 7px' }}> | </span>
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    size="small"
                                    value={day?.secondShiftIni}
                                    onChange={event => viewEmployeeRegistration.handleChangeHorary(event, 'secondShiftIni', null, day)}
                                    style={styles.tyleInput}
                                    InputProps={{
                                        style: styles.inputStyles,
                                        inputComponent: InputMask,
                                        inputProps: {
                                            mask: '99:99',
                                            alwaysShowMask: false,
                                        },
                                    }}
                                />
                                <span style={{ margin: '0 7px' }}> - </span>
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    size="small"
                                    value={day?.secondShiftEnd}
                                    onChange={event => viewEmployeeRegistration.handleChangeHorary(event, 'secondShiftEnd', null, day)}
                                    style={styles.tyleInput}
                                    InputProps={{
                                        style: styles.inputStyles,
                                        inputComponent: InputMask,
                                        inputProps: {
                                            mask: '99:99',
                                            alwaysShowMask: false,
                                        },
                                    }}
                                />
                            </div>
                        </ThemeProvider>
                        :
                        null
                    }
                </Grid>
            ))}
        </div>
    );
};

export default ConfigDays;

const styles = {
    inputStyles: {
        borderRadius: 15,
        height: 25
    },
    horarioContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 90,
        marginLeft: -20
    },
    tyleInput: {
        // border: 'none',
        width: '58px',
        height: '20px',
        fontSize: '0.8em',
        borderRadius: 15
    },
    tyleInputFlex: {
        // border: 'none',
        width: '100px',
        height: '20px',
        fontSize: '1em',
        borderRadius: 15
    },
    InputLeft: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginLeft: -26
    },
    InputRight: {
        height: 40,
        padding: '0 14px',
        borderRadius: 10,
        marginRight: -25
    },
    buttonOne: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '35%',
        height: 30,
        marginLeft: -10,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10,
        textTransform: 'none',
        fontWeight: 'bold'
    },
    buttonTwo: {
        backgroundColor: 'white',
        border: '1px solid #c3c3c3',
        borderRadius: 20,
        textTransform: 'none',
        width: '16%',
        height: 30,
        marginRight: 10,
        color: '#c3c3c3',
        fontFamily: 'montserrat',
        fontSize: 10
    },
    Box: { borderLeft: '1px solid #c3c3c3', height: '30px', marginLeft: '10px', marginRight: 10 },
    avatar: { backgroundColor: 'white', color: '#c3c3c3', border: '1px solid #c3c3c3', width: 30, height: 30, transform: 'rotate(180deg)' },
    textSchedule: {
        display: 'flex',
        marginLeft: -20,
        // color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 9,
        whiteSpace: 'nowrap',
        marginLeft: 4,
        fontWeight: 'bold'
    },
    textShceduleOne: {
        display: 'flex',
        marginLeft: -20,
        fontFamily: 'montserrat',
        fontSize: 9,
        marginTop: 35,
        marginLeft: 5,
        fontWeight: 'bold'
    },
    textScheduleTwo: {
        display: 'flex',
        marginLeft: -20,
        color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 9,
        marginTop: 20,
        whiteSpace: 'nowrap',
        marginBottom: -12,
        marginLeft: 4,
        fontWeight: 'bold'
    },
    scheduleTree: {
        display: 'flex',
        marginLeft: -20,
        color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 9,
        marginTop: 20,
        whiteSpace: 'nowrap',
        marginLeft: 4,
        fontWeight: 'bold'
    },
    horary: {
        display: 'flex',
        marginTop: 90,
        marginLeft: -20,
        color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 13,
        marginBottom: -5
    },
    horaryTwo: {
        display: 'flex',
        marginLeft: -20,
        color: '#464a53',
        fontFamily: 'montserrat',
        fontSize: 13
    }

}

